const en_trans_production = {
    "": "production process",
    goods: "process items",
    add: "add production process",
    edit: "edit production process",
    from_whs: "source warehouse",
    to_whs: "destination warehouse",

    label: {
        process_result: "PROCESS RESULT",
        process_remaing: "REMAINING PROCESS",
        process_start: "start process",
        raw_material: "raw material",
        sign_by: "sign by",

        process_qty: "production quantity",
        process_clear: "clear process",
        process_add: "add process",
        process_save_process: "save and process",

        title_raw_material: "raw material per production",
        title_process_result: "process result per production",
    }
}

export default en_trans_production;